import { createFileRoute } from '@tanstack/react-router';
import { TrainingTracker } from '@/features/workforce/TrainingTracker';

export const Route = createFileRoute('/_app/workforce/training')({ component: TrainingTracker });
